<template>
  <el-row class="container">
    <el-col :span="3">
      <div>
        <el-button type="primary" plain @click="goback" size="mini" class="mb-2" icon="el-icon-arrow-left">
          返回
        </el-button>
      </div>
      <el-tree class="filter-tree" highlight-current node-key="routeName" :current-node-key="$route.name" :data="mulu"
               default-expand-all @node-click="handleNodeClick" ref="tree"></el-tree>
    </el-col>
    <el-col :span="21">
      <el-button type="primary" plain size="small" @click="handleAdd" style="margin-bottom: 10px">新增意见</el-button>
      <!--列表-->
      <el-table :data="tableData" :header-cell-style="{background:'#B4DDD1',color:'#555'}" style="width: 100%"
                ref="multipleTable" @row-dblclick="handleDBClick">
        <el-table-column border label="流程类型" prop="flow_type" show-overflow-tooltip></el-table-column>
        <el-table-column border label="意见" prop="content" show-overflow-tooltip></el-table-column>
        <el-table-column border label="操作人" prop="employee_name" show-overflow-tooltip></el-table-column>
        <el-table-column border label="时间" prop="check_time" show-overflow-tooltip></el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
                     :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
                     layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </el-col>
    <!--对话框-->
    <el-dialog title="新增" :visible.sync="addModel.show" width="800px">
      <el-form v-model="addModel">
        <el-form-item label="意见">
          <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入意见"
              v-model="addModel.content">
          </el-input>
        </el-form-item>
        <el-form-item style="margin-left:200px;margin-top: 30px">
          <el-button type="primary" @click="onAdd">新增</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="意见详情" :visible.sync="editModel.show" width="800px">
      <el-form v-model="editModel">
        <el-form-item label="意见">
          <el-input type="textarea" :rows="10" v-model="editModel.content"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:200px;margin-top: 30px">
          <el-button type="info" @click="onEditClose">取消</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      project_id: '',
      site_id: '',
      site_type: '',
      currentConfig: {},
      tableData: [],
      query: {yj: ""},
      pagination: {current_page: 1, total: 1, per_page: 10,},
      searchConfig: [
        {key: "yj", label: "意见", type: "input"},
      ],
      addModel: {
        show: false,
        cma_zg_type: '直观',
        content: ''
      },
      editModel: {
        show: false,
        content: ''
      },
      mulu: [
        {id: 1, label: '附件1', routeName: 'report_zg_fj1'},
        {id: 2, label: '附件2', routeName: 'report_zg_fj2'},
        {id: 3, label: '附件3', routeName: 'report_zg_fj3'},
        {id: 4, label: '意见', routeName: 'report_zg_yj'},
      ]
    }
  },
  methods: {
    handleDBClick(row) {
      this.editModel.show = true
      Object.keys(row).forEach(key => {
        if (this.editModel.hasOwnProperty(key)) {
          this.editModel[key] = row[key]
        }
      })
    },
    handleAdd() {
      this.addModel.show = true;
    },
    async onAdd() {
      try {
        let params = this.addModel
        delete params.show
        params.project_id = this.project_id
        params.site_id = this.site_id
        await this.$Api.post('check_contents', params)
        this.$message.success("新增成功")
        this.onAddClose()
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onAddClose() {
      this.addModel.show = false
      this.addModel.cma_zg_type = '直观'
      this.addModel.content = ''
    },
    onEditClose() {
      this.editModel.show = false
      this.editModel.content = ''
    },
    goback() {
      this.$router.push({name: `site_${this.$route.params.site_type}_list`, params: this.$route.params})
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.query = {
        site_id: "",
        zg_status: "",
        cma_status: "",
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.pagination,
        };
        params.project_id = this.project_id
        params.site_id = this.site_id
        let data = await this.$Api.get("check_contents", {params: params});
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleNodeClick(data) {
      this.$router.push({
        name: data.routeName,
        params: {project_id: this.project_id, site_id: this.site_id, site_type: this.site_type}
      })
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.getList()
  }
}
</script>

<style scoped>
.mb-2 {
  margin-bottom: 10px;
}

.filter-tree {
  margin-right: 10px;
}

::v-deep .el-tree-node__content {
  padding: 10px 0;
}
</style>
